<div class="progress-bar-container" [ngClass]="size">
  <div class="bar">
    <div class="fill" [ngClass]="state" [style.width.%]="getPercentage()"></div>
  </div>

  <div class="label" *ngIf="showLabel">{{ value }}%</div>
</div>
